import { connect } from 'react-redux';

import OwnNumbersDropDownButton from '../components/OwnNumbersDropDownButton';

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    meta: state.telephony.meta,
    dynamicTelephoneNumbersArray: state.settings.telephony.dynamicOwnNumbers,
    staticTelephoneNumbersArray: state.telephony.numbers,
    nextPage: state.settings.telephony.meta.nextPage,
    previousPage: state.settings.telephony.meta.previousPage,

    roles: ownProps.roles,
    currentDefaultNumber: ownProps.currentDefaultNumber,
    open: ownProps.open,
    selectingDefault: ownProps.selectingDefault,
    setFromNumberCountryCode: ownProps.setFromNumberCountryCode,
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
  return {
    changeDefaultNumber: ownProps.changeDefaultNumber,
    getNumbersByQuery: ownProps.getNumbersByQuery,
    toggleDropdown: ownProps.toggleDropdown,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OwnNumbersDropDownButton);
